

<template>
  <div>
    <div :class="['img-list', { smallImgList: smallImg }]" v-if="images">
      <div class="smallImgWrap" v-for="(item, index) in images" :key="index">
        <img
          :class="['img', { smallImg: smallImg }]"
          :src="getSrc(item)"
          alt
          @click="handleShowViewer(images, index)"
        />
      </div>
    </div>
    <LightBox :items="items" :index="index" @box-close="index = null" />
  </div>
</template>  
<script>
import LightBox from '../LightBox';
export default {
  props: ["images", "smallImg"],
  data() {
    return {
      items: [],
      index: null
    };
  },
  components: {
    LightBox
  },
  computed: {},

  mounted() {
    console.log(this.images);
  },

  methods: {
    getSrc(item) {
      if (typeof item === 'object') {
          if (item.thumbnail) return item.thumbnail;
          if (item.url) return item.url;
      }
      return item;
    },
    getItem(item) {
      if (typeof item === 'object') {
        return {
          src: item.url,
          thumb: item.thumbnail
        }
      }
      return item;
    },
    handleShowViewer(items, index) {
      items.forEach(item => this.items.push(this.getItem(item)));
      this.index = index;
    },
  },
};
</script>
<style lang='less' scoped>
.img-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  div {
    width: 33%;
    img {
      width: 100px;
      height: 100px;
    }
  }
}

.smallImgList {
  width: 260px;
  .smallImgWrap {
    width: 20%;
    .smallImg {
      width: 49px;
      height: 49px;
    }
  }
}
</style>